import { ReactElement } from "react";
import { convertAreaToPx, GridCellPixelValues } from "./GridCellPixelValuesTracker";
import { TilePlaceHolderRenderState } from "./RenderState/common";
import classNames from "classnames";
import styles from "./Tile.module.less";

export type TilePlaceholderProps = {
	placeholder: TilePlaceHolderRenderState;
	cellPixelValues: GridCellPixelValues;
};

export const TilePlaceholder = (props: TilePlaceholderProps): ReactElement => {
	const {
		placeholder,
		cellPixelValues
	} = props;

	return (
		<div
			className={
				classNames(
					styles.root,
					styles.root_placeholder
				)
			}
			style={convertAreaToPx(placeholder, cellPixelValues)}
		/>
	);
};
TilePlaceholder.displayName = "TilePlaceholder";